if($('footer#footer').length){
    $('.site-name-wrapper').append($('footer#footer .cellphone').clone())
    $('.top-navigation-bar .top-navigation-contacts').prepend($('footer#footer .topLink .store'))
    $('.contact-box').prepend('<div class="logoContact"><img src="/user/documents/upload/sablona-nemazat/doprava/logo.png"></div>');
    $('.instagram-widget').prepend('<div class="h4 homepage-group-title">Sledujte nás na Instagramu</div>');
    $(window).on('load', function(){
            $('#formNewsletterWidget button[type="submit"] .sr-only').text('Přihlásit se do newsletteru')
            $('.custom-footer__newsletter').append($('.mimowebHide .newsletterHeader')).wrapInner('<div class="inner"></div>').insertBefore('.instagram-block').removeClass('extended footer-item accordion__item js-accordion-item footer-item-newsletter');
     
    })
}
else{
    if(sessionStorage.loadedFooter) {
              $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooter+'</footer>')
              customFooter()
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooter = $("footer#footer").html();
                    customFooter()
                    }
                });
            }

}

function customFooter(){
   $('.site-name-wrapper').append($('footer#footer .cellphone').clone())
    $('.top-navigation-bar .top-navigation-contacts').prepend($('footer#footer .topLink .store'))
}